import React from 'react';
import Button from '@mui/material/Button'
function UpdateProject() {
  return <div>
      <Button>Delete project</Button>
  </div>;
}

export default UpdateProject;
